export const getInitialsFromName = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return '';
  }

  const firstInitial = words[0]?.[0]?.toUpperCase() ?? '';

  if (words.length === 1) {
    return firstInitial;
  }

  const lastInitial = words[words.length - 1]?.[0]?.toUpperCase() ?? '';

  return `${firstInitial}${lastInitial}`;
};

export const getFileNameFromPath = (documentPath?: string | null): string => {
  if (!documentPath) {
    return '';
  }

  return documentPath.split(/[/\\]/).pop() ?? '';
};
